import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';

const getDefaultHsSitesDomain = () => {
  const portalId = PortalIdParser.get();
  const domainBase = `${portalId}.${enviro.isQa() ? 'hs-sitesqa' : 'hs-sites'}`;
  return enviro.ifHublet({
    isNa1: () => {
      return `${domainBase}.com`;
    },
    isNonNa1: () => {
      return `${domainBase}-${enviro.getHublet()}.com`;
    },
  });
};

export const buildVideoSharePageUrl = (
  videoId: number,
  domainBase?: string
) => {
  const domain = domainBase || getDefaultHsSitesDomain();
  return `https://${domain}/share/hubspotvideo/${videoId}`;
};
